<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
<div class="dashboard-container">
<app-admin-nav></app-admin-nav>

<div id="dashboard">
    <div class="overview">
        <div class="text-area">
            <span class="title">{{ 'dashboard_overview_title' | translate }}</span>
            <span class="subtitle">{{ 'dashboard_overview_period' | translate }}</span>
        </div>
        <div class="card-area">
            <div class="card">
                <div class="card-title">
                    <img src="assets/images/dashboard/euro-icon.png" [alt]="'dashboard_card_revenue' | translate">
                    <span>{{ 'dashboard_card_revenue' | translate }}</span>
                </div>
                <div class="card-value">{{ dashboardStats.totalRevenue || 0 }}€</div>
                <div class="comparison">
                    <div class="comparison-box">
                        <div class="label">{{ 'dashboard_card_avg_order_value' | translate }}</div>
                        <div class="value">{{ dashboardStats.avgOrderValue || 0 }}€</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-title">
                    <img src="assets/images/dashboard/cart-icon.png" [alt]="'dashboard_card_total_orders' | translate">
                    <span>{{ 'dashboard_card_total_orders' | translate }}</span>
                </div>
                <div class="card-value">{{ dashboardStats.totalOrders || 0 }}</div>
                <div class="comparison">
                    <div class="comparison-box">
                        <div class="label">{{ 'dashboard_orders_new' | translate }}</div>
                        <div class="value">{{ statusCount('New') }}</div>
                    </div>
                    <div class="comparison-box">
                        <div class="label">{{ 'dashboard_orders_completed' | translate }}</div>
                        <div class="value">{{ statusCount('Completed') }}</div>
                    </div>
                    <div class="comparison-box">
                        <div class="label">{{ 'dashboard_orders_cancelled' | translate }}</div>
                        <div class="value">{{ statusCount('Cancelled') }}</div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-title">
                    <img src="assets/images/dashboard/people-icon.png" [alt]="'dashboard_card_customers' | translate">
                    <span>{{ 'dashboard_card_customers' | translate }}</span>
                </div>
                <div class="card-value">{{ dashboardStats.customers?.total || 0 }}</div>
                <div class="comparison">
                    <div class="comparison-box">
                        <div class="label">{{ 'dashboard_customers_new' | translate }}</div>
                        <div class="value">{{ dashboardStats.customers?.new || 0 }}</div>
                    </div>
                    <div class="comparison-box">
                        <div class="label">{{ 'dashboard_customers_returning' | translate }}</div>
                        <div class="value">{{ dashboardStats.customers?.returning || 0 }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="orders">
        <span class="header">{{ 'dashboard_latest_orders' | translate }}</span>
        <!-- Scrolls horizontally on narrow screens; the page itself clips
             overflow (html/body use overflow-x: hidden). -->
        <div class="table-scroll">
        <table mat-table [dataSource]="orders" class="custom-table">

            <!-- Order ID -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_order_no' | translate }} </th>
                <td mat-cell *matCellDef="let order"> #{{ order.orderNo }} </td>
            </ng-container>

            <!-- Client Name -->
            <ng-container matColumnDef="clientName">
                <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_client_email' | translate }} </th>
                <td mat-cell *matCellDef="let order"> {{ order.contactDetails.email }} </td>
            </ng-container>

            <!-- Date -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_date' | translate }} </th>
                <td mat-cell *matCellDef="let order"> {{ order.createdAt | customDate }} </td>
            </ng-container>

            <!-- Amount -->
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_amount' | translate }} </th>
                <td mat-cell *matCellDef="let order"> €{{ order.totalPrice }} </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_status' | translate }} </th>
                <td mat-cell *matCellDef="let order">
                    <span class="status" [ngClass]="order.status?.toLowerCase()">
                        <span class="dot"></span> {{ order.status }}
                    </span>
                </td>
            </ng-container>

            <!-- Assigned -->
            <ng-container matColumnDef="assignedTo">
                <th mat-header-cell *matHeaderCellDef> {{ 'orders_table_assigned_to' | translate }} </th>
                <td mat-cell *matCellDef="let order"> {{ order.assignedTo ? order.assignedTo : '-' }} </td>
            </ng-container>

            <!-- Menu -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let order">
                    <i class="fa-solid fa-eye cursor-pointer" style="color: #96A6B7;" (click)="viewOrder(order)"></i>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        </div>
    </div>

</div>
</div>
</div>

<app-footer></app-footer>